// src/api/endpoints.js
import config from '../config';

const BASE_URL = config.apiUrl;

export const endpoints = {
    submitData: `${BASE_URL}/data/submit`,
    pendingSubmissions: `${BASE_URL}/moderation/pending_submissions`,
    allSubmissions: `${BASE_URL}/moderation/all`,
    moderation: (id, action) => `${BASE_URL}/moderation/${id}/${action}`,
    updateStatus: (id) => `${BASE_URL}/moderation/${id}/status`,
    bulkUpdateStatus: `${BASE_URL}/moderation/status/bulk`,
    deleteRecord: (id) => `${BASE_URL}/moderation/${id}`,
    moderationStats: `${BASE_URL}/moderation/stats`,
    analyticsView: `${BASE_URL}/analytics/view`,
    analyticsStats: `${BASE_URL}/analytics/stats`,
    downloadExcel: `${BASE_URL}/cache/download/excel`,
    downloadCsv: `${BASE_URL}/cache/download/csv`,
    downloadImages: `${BASE_URL}/cache/download/images`,
    downloadCount: `${BASE_URL}/cache/download/count`,
    listVersions: `${BASE_URL}/cache/download/versions`,
    downloadVersionExcel: (id) => `${BASE_URL}/cache/download/excel/${id}`,
    downloadVersionCsv: (id) => `${BASE_URL}/cache/download/csv/${id}`,
    downloadVersionImages: (id) => `${BASE_URL}/cache/download/images/${id}`,
    getImageContent: (id) => `${BASE_URL}/images/${id}/content`,
    uploadImage: `${BASE_URL}/images/upload`,
    deleteImage: (id) => `${BASE_URL}/images/${id}`,
    AllDatasetJson: `${BASE_URL}/cache/download/json`,
    ForgotPassword: `${BASE_URL}/auth/forgot-password`,
    ResetPassword: `${BASE_URL}/auth/reset-password`,
    Login: `${BASE_URL}/auth/login`,
    Register: `${BASE_URL}/auth/register`,
    RefreshToken: `${BASE_URL}/auth/refresh`,
    Logout: `${BASE_URL}/auth/logout`,
    GetCurrentUser: `${BASE_URL}/auth/me`,
    VerifyEmail: `${BASE_URL}/auth/verify-email`,
    ResendVerification: `${BASE_URL}/auth/resend-verification`,
    GetUserProfile: `${BASE_URL}/auth/profile`,
    UpdateProfile: `${BASE_URL}/auth/profile`,
    ChangePassword: `${BASE_URL}/auth/change-password`,
    ListContributors: `${BASE_URL}/contributors/list`,
    RefreshContributorsCache: `${BASE_URL}/contributors/cache/refresh`,
    RefreshDatasetCache: `${BASE_URL}/export/cache/refresh-cache`,
    RefreshImageCache: `${BASE_URL}/export/cache/refresh-images`,
    SubmitFeedback: `${BASE_URL}/feedback/submit`,
    GetAllFeedback: `${BASE_URL}/feedback/all`,
    // Admin User Management
    AdminGetAllUsers: `${BASE_URL}/admin/users`,
    AdminGetUsersPage: `${BASE_URL}/admin/users/page`,
    AdminDeleteUser: (id) => `${BASE_URL}/admin/users/${id}`,
    AdminUpdateUserRole: (id) => `${BASE_URL}/admin/users/${id}/role`,
    AdminToggleUserEnabled: (id) => `${BASE_URL}/admin/users/${id}/toggle-enabled`,
    // Admin Dataset Version Management
    AdminListDatasetVersions: `${BASE_URL}/admin/dataset-versions`,
    AdminUpdateDatasetVersion: (id) => `${BASE_URL}/admin/dataset-versions/${id}`,
    ArchiveFeedback: (id) => `${BASE_URL}/feedback/${id}/archive`,
    // Admin Email Center
    EmailTemplates: `${BASE_URL}/admin/email/templates`,
    EmailTemplate: (id) => `${BASE_URL}/admin/email/templates/${id}`,
    EmailTemplateDuplicate: (id) => `${BASE_URL}/admin/email/templates/${id}/duplicate`,
    EmailTemplateFavorite: (id) => `${BASE_URL}/admin/email/templates/${id}/favorite`,
    EmailTemplateVersions: (id) => `${BASE_URL}/admin/email/templates/${id}/versions`,
    EmailRecipientsEstimate: `${BASE_URL}/admin/email/recipients/estimate`,
    EmailRecipientsValidate: `${BASE_URL}/admin/email/recipients/validate`,
    EmailRecipientsCsvImport: `${BASE_URL}/admin/email/recipients/csv-import`,
    EmailRecipientsSearch: (q) => `${BASE_URL}/admin/email/recipients/search?q=${encodeURIComponent(q)}`,
    EmailRecipientGroups: `${BASE_URL}/admin/email/recipient-groups`,
    EmailRecipientGroup: (id) => `${BASE_URL}/admin/email/recipient-groups/${id}`,
    EmailCampaigns: `${BASE_URL}/admin/email/campaigns`,
    EmailCampaign: (id) => `${BASE_URL}/admin/email/campaigns/${id}`,
    // Drafts and sends are stateless, idempotencyKey-driven POSTs against the collection
    // (not id-scoped) - see EmailCampaignService.createDraft/send on the backend.
    EmailCampaignDrafts: `${BASE_URL}/admin/email/campaigns/drafts`,
    EmailCampaignSend: `${BASE_URL}/admin/email/campaigns/send`,
    EmailCampaignCancel: (id) => `${BASE_URL}/admin/email/campaigns/${id}/cancel`,
    EmailCampaignResend: (id) => `${BASE_URL}/admin/email/campaigns/${id}/resend`,
    EmailCampaignDuplicate: (id) => `${BASE_URL}/admin/email/campaigns/${id}/duplicate`,
    EmailCampaignSendTest: `${BASE_URL}/admin/email/campaigns/send-test`,
    EmailCampaignAttachments: (id) => `${BASE_URL}/admin/email/campaigns/${id}/attachments`,
    EmailCampaignsExport: `${BASE_URL}/admin/email/campaigns/export`,
    EmailAuditLog: `${BASE_URL}/admin/email/audit-log`,
    EmailPlaceholders: `${BASE_URL}/admin/email/placeholders`,
    EmailConfig: `${BASE_URL}/admin/email/config`,
    EmailAnalyticsSummary: `${BASE_URL}/admin/email/analytics/summary`,
    // Metadata Management
    MetadataPolymers: `${BASE_URL}/metadata/polymers`,
    MetadataSolvents: `${BASE_URL}/metadata/solvents`,
    MetadataMorphologies: `${BASE_URL}/metadata/morphologies`,
    MetadataInstabilities: `${BASE_URL}/metadata/instabilities`,
    MetadataInstability: (id) => `${BASE_URL}/metadata/instabilities/${id}`,
    MetadataUnits: `${BASE_URL}/metadata/units`,
    MetadataPolymer: (id) => `${BASE_URL}/metadata/polymers/${id}`,
    MetadataSolvent: (id) => `${BASE_URL}/metadata/solvents/${id}`,
    MetadataMorphology: (id) => `${BASE_URL}/metadata/morphologies/${id}`,
    MetadataAdditives: `${BASE_URL}/metadata/additives`,
    MetadataAdditive: (id) => `${BASE_URL}/metadata/additives/${id}`,
    MetadataMonomers: `${BASE_URL}/metadata/monomers`,
    MetadataMonomer: (id) => `${BASE_URL}/metadata/monomers/${id}`,
    MetadataUnit: (id) => `${BASE_URL}/metadata/units/${id}`,
    MetadataPolymerByCas: (cas) => `${BASE_URL}/metadata/polymers/search?cas=${cas}`,
    MetadataSolventByCas: (cas) => `${BASE_URL}/metadata/solvents/search?cas=${cas}`,
    MetadataSolventByCas: (cas) => `${BASE_URL}/metadata/solvents/search?cas=${cas}`,
    // Data Editing
    getExperimentData: (id) => `${BASE_URL}/data/experiment/${id}`,
    getSubmissionData: (id) => `${BASE_URL}/data/submission/${id}`,
    updateExperiment: (id) => `${BASE_URL}/data/update-submission/${id}`,
    withdrawSubmission: (id) => `${BASE_URL}/data/submission/${id}`,
    mySubmissions: `${BASE_URL}/data/my-submissions`,
    casSearch: `${BASE_URL}/cas/search`,
    casQuery: `${BASE_URL}/cas/query`,

};
